import type { ProductModel } from '../../../types';

export const getProductUrl = (product: ProductModel, isAbsolute: boolean = true) => {
    const createLeadingSlashUrl = (url: string) => {
        if (url?.startsWith('/')) return url;
        return `/${url}`;
    };

    const { url_key, url_suffix, canonical_url } = product;
    let baseUrl = process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT ?? '';

    // Check if the base URL ends with a slash and remove it if it does
    if (baseUrl.endsWith('/')) {
        baseUrl = baseUrl.slice(0, -1);
    }

    let relativeUrl = `${createLeadingSlashUrl(url_key ?? '')}${url_suffix}`;
    if (canonical_url) {
        relativeUrl = createLeadingSlashUrl(canonical_url);
    }

    return isAbsolute ? `${baseUrl}${relativeUrl}` : `${relativeUrl}`;
};
